import script from "./ImprovementList.vue?vue&type=script&setup=true&lang=js"
export * from "./ImprovementList.vue?vue&type=script&setup=true&lang=js"

import "./ImprovementList.vue?vue&type=style&index=0&id=f7e1c742&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7e1c742"]])

export default __exports__